module.exports = __webpack_public_path__ + "img/kontak.32fa1b28.svg";